import { ReactNode } from 'react';

export type ModalProps = {
  open: boolean;
  onClose: () => void;
};

export type Children<T = ReactNode> = {
  children: T;
};

export type ClassName = {
  className?: string;
};

export enum SnackbarStatus {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

export interface ISnackbar {
  id: string;
  text: string;
  status?: SnackbarStatus;
  timeout?: number;
  onClick?: () => void;
}
